export function fetchSearchResults(
  searchText,
  pageNumber
) {
  console.log("in fetchSearchResults");
  console.log("submitting request to search organization ", searchText);
  console.log("url is " + process.env.REACT_APP_HOST_API_URL);
  return fetch(
    process.env.REACT_APP_HOST_API_URL +
      "/developer/mvc/api/organizations/firstnet/search?orgSearchText=" +
      searchText +
      "&pageNumber=" +
      pageNumber,
    {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    }
  )
    .then(response => response.json())
    .catch(error => {
      console.log("error trying to process org search response : \n", error);
      window.location.href =
        process.env.REACT_APP_HOST_API_URL +
        "/developer/errorRedirect.jsp?errorKey=request.processing.error";
      return Promise.reject();
    });
}



// WEBPACK FOOTER //
// ./src/firstnet/search/organization/api/SearchResultsFetcher.js